import { useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { SearchCriteriaDup } from "./searchCriteriaDup";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";

import ClearIcon from "@mui/icons-material/Clear";
import ApiServices from "../../../service/apiService";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { FetchAllUsers } from "@mikros/library";
import { Textarea } from "@mui/joy";

export interface TextBoxCreationDupProps {
  state: string;
  cohortLandState: Function;
  refreshedCohorts: () => void;
  newCohortState: () => void;
}
export function TextBoxCreationDup(props: TextBoxCreationDupProps) {
  const intl = useIntl();
  const maxUserNameLimit = 50;
  const maxCharLimit = 50;
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const nameRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&\-#()]+$/);
  const workRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&#${}()\-\[\]]+$/);
  console.log("cohort land state in textboxCreation", props.cohortLandState);

  const hasMoreData = useRef(true);
  const [errors, setErrors] = useState<any>({});
  const [cname, setCname] = useState<string>();
  const [description, setDescription] = useState<string>();
  const [formData, setFormData] = useState({
    firstName: "",
    branchName: "",
    department: "",
    location: "",
    designation: "",
    email: "",
    phNo: "",
  });

  const languages = [
    intl.formatMessage({ id: "language.english" }),
    intl.formatMessage({ id: "language.hindi" }),
    intl.formatMessage({ id: "language.tamil" }),
    intl.formatMessage({ id: "language.isEmpty" }),
  ];
  const allValue = intl.formatMessage({ id: "allValue" });

  const [selectedLanguage, setSelectedLanguage] = useState<string[]>([
    ...languages,
  ]);
  const [fetchAllUser, setFetchAllUser] = useState<boolean>(false);
  const [userFetchModel, setUserFetchModel] = useState<FetchAllUsers>({
    users: [],
    lastKey: "",
  });
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [totalUserCount, setTotalUserCount] = useState<number>(0);
  const [searchActive, setSearchActive] = useState(false);

  const validators = {
    userNameValidator: (value: string) =>
      value === "" || nameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "analytics.userView.userNameValidation",
          })}`,

    deptRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.departmentValidation",
          })}`,
    desgRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.designationValidation",
          })}`,
    branchRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.branchValidation" })}`,
    locationRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.locationValidation" })}`,
    // emailRegexValidator: (value: string) =>
    //   value
    //     ? emailRegex.test(value)
    //       ? ""
    //       : `${intl.formatMessage({
    //           id: "user.createUser.emailValidation",
    //         })}`
    //     : "",
    // mobileRegexValidator: (value: string) =>
    //   value
    //     ? mobileRegex.test(value)
    //       ? ""
    //       : `${intl.formatMessage({
    //           id: "shareCustomer.mobileNumberValidation",
    //         })}`
    //     : "",
  };

  const validateCohortName = () => {
    let newErrors: { cohortName?: string } = {};
    if (!cname?.trim()) {
      newErrors.cohortName = intl.formatMessage({
        id: "user.textBoxCreation.cohortNameRequired",
      });
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [searchClicked, setSearchClicked] = useState<boolean>(false);

  const cohortNameRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&\-#()]+$/);
  const cohortDescRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&\-#()]+$/);

  console.log("Print state", props.state);
  async function signIn(formData: { [name: string]: any }) {}

  const [showForm, setShowForm] = useState(true);
  const [showSearchCriteria, setShowSearchCriteria] = useState(true);
  const [showTextbox, setShowTextBox] = useState(true);
  console.log("print form state", showForm);
  console.log("print search criteria state", showSearchCriteria);

  console.log("inside text box creation dup");

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    console.log("inside handl change name", name);
    console.log("inside handle change value", value);
    // Validate and keep the error until the entire input is valid
    // const errorMsg = validators.userNameValidator(value);
    let errorMsg = "";
    if (name === "firstName") {
      console.log("inside user name validator");
      errorMsg = validators.userNameValidator(value);
    } else if (name === "branchName") {
      console.log("inside branch validator");
      errorMsg = validators.branchRegexValidator(value);
    } else if (name === "department") {
      console.log("inside dept validator");
      errorMsg = validators.deptRegexValidator(value);
    } else if (name === "location") {
      console.log("inside location validator");
      errorMsg = validators.locationRegexValidator(value);
    } else if (name === "designation") {
      console.log("inside desg validator");
      errorMsg = validators.desgRegexValidator(value);
    } else if (name === "phNo") {
      console.log("inside phNo validator");
      // errorMsg = validators.mobileRegexValidator(value);
    } else if (name === "email") {
      console.log("inside email validator");
      // errorMsg = validators.emailRegexValidator(value);
    }

    setErrors((prev: any) => ({
      ...prev,
      [name]: errorMsg, // Only update the specific field
    }));
  };

  const handleItemClick = (lang: string) => {
    let updatedSelection = [...selectedLanguage];
    if (lang === allValue) {
      updatedSelection = [...languages];
    } else {
      if (updatedSelection.includes(lang)) {
        updatedSelection = updatedSelection.filter((l) => l != lang);
      } else {
        updatedSelection.push(lang); //check
      }
    }
    if (updatedSelection.length === languages.length) {
      updatedSelection = [...languages];
    }
    setSelectedLanguage(updatedSelection);
  };
  const renderValue = (selected: string[]) => {
    if (selected.length === languages.length) {
      return allValue;
    }
    return selected.join(",");
  };
  const handleClear = (field: string) => {
    setFormData({
      ...formData,
      [field]: "",
    });

    setErrors((prev: any) => ({ ...prev, [field]: "" }));
  };

  const handleClearAll = () => {
    setFormData({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
      email: "",
      phNo: "",
    });
    setErrors({});

    if (searchClicked) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            // `${accountInstance.accntId}/user/filter?limit=20`,
            `${accountInstance.accntId}/user?limit=20`,
            "GET"
          )
          .then(async (data) => {
            if (data && data.errorMessage) {
              console.log("I entered error code handling in users");
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
              return;
            } else {
              const activeUsers =
                data?.users?.filter((user: any) => user.status === "ACTIVE") ||
                [];
              setUserFetchModel({ ...data, users: activeUsers });
              setTotalUserCount(activeUsers.length);
              // setSearchActive(true);
              setSearchActive(false);
              setSelectedLanguage([allValue]);
              handleItemClick(allValue);
              hasMoreData.current = true;
            }
          });
      }
      setSearchClicked(false); // Reset the search click status
    }
  };

  const handleSearch = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    console.log("Inside handle search:", formData);

    setSearchClicked(true);

    //  Build the query string dynamically
    const filters = [
      "firstName",
      "branchName",
      "department",
      "location",
      "designation",
      "email",
      "phNo",
    ];

    const isAllSelected = selectedLanguage.length === languages.length;

    const languageQuery = isAllSelected
      ? ""
      : selectedLanguage
          .map((lang) => (lang === "is empty" ? "isEmpty" : lang)) // Replace "is empty" with "isEmpty"
          .join(",");

    const queryParams = [
      ...(isAllSelected || !languageQuery
        ? []
        : [`languages=${encodeURIComponent(languageQuery)}`]), // Encode language values properly
      ...Object.entries(formData)
        .filter(([_, value]) => typeof value === "string" && value.trim()) // Remove empty fields
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value.trim())}` // Encode both keys & values
        ),
    ].join("&");

    const apiUrl = `${accountInstance.accntId}/user/filter${
      queryParams ? `?${queryParams}` : ""
    }`;

    // console.log("Query String:", queryParams);

    const api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api.makeRequest(apiUrl, "GET").then(async (data) => {
        if (data && data.errorMessage) {
          console.log("I entered error code handling in users");
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data.errorMessage);
          return;
        } else {
          console.log("user fetch model data", userFetchModel);
          // setFormData(data);
          const activeUsers =
            data?.users?.filter((user: any) => user.status === "ACTIVE") || [];
          setUserFetchModel({ ...data, users: activeUsers });
          setTotalUserCount(activeUsers.length);
          setSearchActive(true);
          const hasDataLeft = data?.lastKey !== null;
          hasMoreData.current = hasDataLeft;
        }
      });
    }
  };

  const cohortValidators = {
    cohortNameValidator: (value: string) =>
      !value
        ? intl.formatMessage({ id: "user.searchCriteria.cohortNameValidation" })
        : cohortNameRegex.test(value)
        ? ""
        : intl.formatMessage({
            id: "user.searchCriteria.cohortNameAnotherValidation",
          }),

    cohortDescValidator: (value: string) =>
      !value
        ? ""
        : cohortDescRegex.test(value)
        ? ""
        : intl.formatMessage({ id: "user.searchCriteria.cohortDescription" }),
  };

  console.log("desc log", description);
  return (
    <div className="mt-4">
      {showForm && showSearchCriteria && (
        <form onSubmit={signIn}>
          <div className="grid grid-cols-3 gap-2">
            {" "}
            {/* Horizontal layout with spacing */}
            <div>
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  <FormattedMessage id="user.searchCriteria.nameToCohort" />
                </Typography>
                <TextField
                  name="cname"
                  id="cname"
                  value={cname}
                  error={!!errors.cohortName}
                  helperText={errors.cohortName}
                  onChange={(e) => setCname(e.target.value)}
                  inputProps={{ maxLength: 30 }}
                  fullWidth
                  variant="outlined"
                  sx={{
                    backgroundColor: "white",
                    "& .MuiFormHelperText-root": {
                      backgroundColor: "var(--color-mk-primary-10)",
                      width: "16rem",
                      textAlign: "left",
                      margin: 0,
                    },
                  }}
                />
              </FormControl>
            </div>
            {/* Cohort Description */}
            <div>
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  <FormattedMessage id="user.searchCriteria.description" />
                </Typography>
                {/* <TextareaAutosize
                  name="cdesc"
                  id="cdesc"
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    console.log("Description", e.target.value);
                  }}
                  minRows={2}
                  maxRows={2}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "16px",
                    backgroundColor: "white",
                  }}
                /> */}

<Textarea
            minRows={2}
            maxRows={2}
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              console.log("Description", e.target.value);
            }}
            sx={{
              backgroundColor: "var(--color-mk-white)",
              // border: "1px solid #E1E2E9",
              border:"1px solid var(--color-mk-primary)",
              "&::before, &::after": {
                display: "none !important", // Removes default Joy UI focus styles
              },
              "&:focus-within": {
                border: "2px solid var(--color-mk-primary)", // Custom focus border color (change as needed)
              },
            }}
          />
              </FormControl>
            </div>
          </div>
          <div className="pb-[2%]"></div>
          <div className="text-mk-primary-bright text-2xl font-semibold">
            <FormattedMessage id="analytics.userView.searchUsers" />
          </div>
          <Card sx={{ p: 1, mb: 2 }}>
            <CardContent>
              {/* <form onSubmit={handleSearch}> */}
              <div onSubmit={handleSearch}>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <FormControl margin="dense" sx={{ width: "16rem" }}>
                      <Typography variant="subtitle1">
                        <FormattedMessage id="analytics.userView.userName" />
                      </Typography>
                      <TextField
                        error={!!errors.firstName}
                        helperText={errors.firstName}
                        InputLabelProps={{ shrink: false }}
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        sx={{
                          "& input:-webkit-autofill, & input:-webkit-autofill:focus, & input:-webkit-autofill:hover, & input:-webkit-autofill:active":
                            {
                              WebkitBoxShadow:
                                "0 0 0 1000px white inset !important", // Apply white background within bounds
                              WebkitTextFillColor: "black !important",
                              transition:
                                "background-color 9999s ease-out 0s !important",
                              height: "0.005rem !important",
                            },
                        }}
                        inputProps={{ maxLength: maxUserNameLimit }}
                        InputProps={{
                          disableUnderline: true,
                          style: { backgroundColor: "white" },
                          endAdornment: (
                            <InputAdornment position="end">
                              {formData.firstName && (
                                <IconButton
                                  onClick={() => handleClear("firstName")}
                                  edge="end"
                                  size="small"
                                  sx={{
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                      backgroundColor: "#E1E2E9",
                                    },
                                  }}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </div>
                  <div>
                    <FormControl margin="dense" sx={{ width: "16rem" }}>
                      <Typography variant="subtitle1">
                        {/* Branch */}
                       <FormattedMessage id="user.textBoxCreation.emailId"/>
                      </Typography>
                      <TextField
                        error={!!errors.email}
                        helperText={errors.email}
                        InputLabelProps={{ shrink: false }}
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        inputProps={{ maxLength: maxCharLimit }}
                        InputProps={{
                          disableUnderline: true,
                          style: { backgroundColor: "white" },
                          endAdornment: (
                            <InputAdornment position="end">
                              {formData.email && (
                                <IconButton
                                  onClick={() => handleClear("email")}
                                  edge="end"
                                  size="small"
                                  sx={{
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                      backgroundColor: "#E1E2E9",
                                    },
                                  }}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </div>

                  <div>
                    <FormControl margin="dense" sx={{ width: "16rem" }}>
                      <Typography variant="subtitle1">
                        {/* Department */}
                       <FormattedMessage id="user.textBoxCreation.mobileNumber"/>
                      </Typography>
                      <TextField
                        error={!!errors.phNo}
                        helperText={errors.phNo}
                        InputLabelProps={{ shrink: false }}
                        name="phNo"
                        value={formData.phNo}
                        onChange={handleChange}
                        inputProps={{ maxLength: maxCharLimit }}
                        InputProps={{
                          disableUnderline: true,
                          style: { backgroundColor: "white" },
                          endAdornment: (
                            <InputAdornment position="end">
                              {formData.phNo && (
                                <IconButton
                                  onClick={() => handleClear("phNo")}
                                  edge="end"
                                  size="small"
                                  sx={{
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                      backgroundColor: "#E1E2E9",
                                    },
                                  }}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <FormControl margin="dense" sx={{ width: "16rem" }}>
                      <Typography variant="subtitle1">
                        {/* Location */}
                        <FormattedMessage id="analytics.userView.location" />
                      </Typography>
                      <TextField
                        error={!!errors.location}
                        helperText={errors.location}
                        InputLabelProps={{ shrink: false }}
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        inputProps={{ maxLength: maxCharLimit }}
                        InputProps={{
                          disableUnderline: true,
                          style: { backgroundColor: "white" },
                          endAdornment: (
                            <InputAdornment position="end">
                              {formData.location && (
                                <IconButton
                                  onClick={() => handleClear("location")}
                                  edge="end"
                                  size="small"
                                  sx={{
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                      backgroundColor: "#E1E2E9",
                                    },
                                  }}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </div>
                  <div>
                    <FormControl margin="dense" sx={{ width: "16rem" }}>
                      <Typography variant="subtitle1">
                        {/* Designation */}
                        <FormattedMessage id="analytics.userView.desg" />
                      </Typography>
                      <TextField
                        error={!!errors.designation}
                        helperText={errors.designation}
                        InputLabelProps={{ shrink: false }}
                        name="designation"
                        value={formData.designation}
                        onChange={handleChange}
                        inputProps={{ maxLength: maxCharLimit }}
                        InputProps={{
                          disableUnderline: true,
                          style: { backgroundColor: "white" },
                          endAdornment: (
                            <InputAdornment position="end">
                              {formData.designation && (
                                <IconButton
                                  onClick={() => handleClear("designation")}
                                  edge="end"
                                  size="small"
                                  sx={{
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                      backgroundColor: "#E1E2E9",
                                    },
                                  }}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </div>
                  <div>
                    <FormControl margin="dense" sx={{ width: "16rem" }}>
                      <Typography variant="subtitle1">
                        {/* Designation */}
                       <FormattedMessage id="user.textBoxCreation.department"/>
                      </Typography>
                      <TextField
                        error={!!errors.department}
                        helperText={errors.department}
                        InputLabelProps={{ shrink: false }}
                        name="department"
                        value={formData.department}
                        onChange={handleChange}
                        inputProps={{ maxLength: maxCharLimit }}
                        InputProps={{
                          disableUnderline: true,
                          style: { backgroundColor: "white" },
                          endAdornment: (
                            <InputAdornment position="end">
                              {formData.department && (
                                <IconButton
                                  onClick={() => handleClear("department")}
                                  edge="end"
                                  size="small"
                                  sx={{
                                    backgroundColor: "transparent",
                                    "&:hover": {
                                      backgroundColor: "#E1E2E9",
                                    },
                                  }}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-2">
                  {/* <div> */}
                  <FormControl margin="dense" sx={{ width: "16rem" }}>
                    <Typography variant="subtitle1">
                      {/* Location */}
                     <FormattedMessage id="user.textBoxCreation.branch"/>
                    </Typography>
                    <TextField
                      error={!!errors.branchName}
                      helperText={errors.branchName}
                      InputLabelProps={{ shrink: false }}
                      name="branchName"
                      value={formData.branchName}
                      onChange={handleChange}
                      inputProps={{ maxLength: maxCharLimit }}
                      InputProps={{
                        disableUnderline: true,
                        style: { backgroundColor: "white" },
                        endAdornment: (
                          <InputAdornment position="end">
                            {formData.branchName && (
                              <IconButton
                                onClick={() => handleClear("branchName")}
                                edge="end"
                                size="small"
                                sx={{
                                  backgroundColor: "transparent",
                                  "&:hover": {
                                    backgroundColor: "#E1E2E9",
                                  },
                                }}
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>

                  <FormControl margin="dense" sx={{ width: "16rem" }}>
                    <Typography variant="subtitle1">Language</Typography>
                    <Select
                      labelId="language-select-label"
                      id="language-select"
                      multiple
                      value={selectedLanguage}
                      onChange={handleChange}
                      // input={<OutlinedInput label="Language" />}
                      renderValue={renderValue}
                      // MenuProps={MenuProps}
                    >
                      {/* "All" option */}
                      <MenuItem
                      disableRipple
                        key={allValue}
                        value={allValue}
                        onClick={() => handleItemClick(allValue)}
                      >
                        <Checkbox
                        disableRipple
                          checked={selectedLanguage.length === languages.length}
                          sx={{
                            "&.Mui-checked": { color: "var-mk-very-dark-grey" },
                          }}
                        />
                        <ListItemText primary={allValue} />
                      </MenuItem>

                      {/* Individual language options */}
                      {languages.map((lang) => (
                        <MenuItem
                        disableRipple
                          key={lang}
                          value={lang}
                          onClick={() => handleItemClick(lang)}
                        >
                          <Checkbox 
                          disableRipple
                          checked={selectedLanguage.includes(lang)} />
                          <ListItemText primary={lang} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/* </div> */}
                  {/* <div className="flex justify-end items-end"> */}
                  <div className="flex justify-start items-center space-x-2">
                    <Button
                      type="submit"
                      variant="contained"
                      disableRipple
                      onClick={handleSearch}
                      sx={{
                        mt: 2,
                        borderRadius: "8px",
                        textTransform: "capitalize",
                        color: "white",

                        backgroundColor: "#6464E5",
                        "&:hover": {
                          backgroundColor: "#E1E2E9",
                          color: "black",
                        },
                        display: "inline-block",
                      }}
                    >
                      <FormattedMessage id="analytics.userView.search" />
                    </Button>
                    <Button
                      type="button" // Use 'button' type to prevent form submission
                      variant="contained"
                      disableRipple // Disable ripple effect
                      sx={{
                        mt: 2,
                        borderRadius: "8px",
                        textTransform: "capitalize",
                        color: "black",

                        backgroundColor: "#E1E2E9",
                        "&:hover": {
                          backgroundColor: "#E1E2E9",
                        },

                        display: "inline-block",
                      }}
                      onClick={() => {
                        handleClearAll();
                      }}
                    >
                      <FormattedMessage id="analytics.userView.clear" />
                    </Button>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          {/* SearchCriteriaDup Component */}
          <div className="pb-[2%]"></div>
          <SearchCriteriaDup
            validateAndSetError={validateCohortName}
            cohortName={cname}
            description={description}
            state={props.state}
            cohortLandState={props.cohortLandState}
            textBoxState={setShowTextBox}
            refreshedCohorts={props.refreshedCohorts}
            newCohortState={props.newCohortState}
            errorState={setErrors}
            searchCriteriaState={setShowSearchCriteria}
            formState={setShowForm}
            userData={userFetchModel}
            userDataFunction={setUserFetchModel}
            search={searchActive}
            searchFunction={setSearchActive}
            totalCount={totalUserCount}
            totalCountFunction={setTotalUserCount}
            formData={formData}
            formDataFunction={setFormData}
            hasMoreDataReference={hasMoreData}
            selectedLanguage={selectedLanguage}
            selectedLanguageFunction={setSelectedLanguage}
            languages={languages}
          />
        </form>
      )}
    </div>
  );
}
